export default __webpack_public_path__ + "static/sie-623b34d9a647d5e6fedbee245a3b0e6c.jpg";